import React from 'react';

import { useUser } from '../../../../api/user/useUser';
import {
  Button,
  Message,
} from '@helios/frontend-core';

import styles from './ImpersonationBanner.module.scss';

export interface ImpersonationBannerProps {
  forceImpersonationBanner: boolean;
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = (props: ImpersonationBannerProps) => {
  const { forceImpersonationBanner } = props;

  const { isImpersonatedUser, stopImpersonating, user } = useUser();

  const endImpersonation = () => {
    stopImpersonating();
    window.location.reload();
  };

  if (!isImpersonatedUser() && !forceImpersonationBanner) {
    return null;
  }

  const impersonatedUserName: string | undefined =
    (isImpersonatedUser() || forceImpersonationBanner) && user ? `${user.firstName} ${user.lastName}` : undefined;
  return (
    <div className="px-8 pt-8 md:px-24 md:pt-24">
      <Message color="yellow" hasIcon className={styles.impersonating}>
        <span className={styles.impersonatedUserName}>Impersonating {impersonatedUserName}</span>
        <Button onClick={endImpersonation} size="small" trackingId="impersonation-stop" layout="hug">
          Stop
        </Button>
      </Message>
    </div>
  );
};

export default ImpersonationBanner;
